import axiosClient from "./axiosClient.js";

const outboxApi = {
  /**
   * Bulk lookup for persisted optimistic messages after reload.
   * @param {string} shopId
   * @param {string[]} cliMsgIds
   * @returns {Promise<{ statuses: Record<string, { outboxId, status, msgId, lastError, sentAt, persistedMessages?: Array }> }>}
   */
  getStatus: async (shopId, cliMsgIds) => {
    if (!shopId || !Array.isArray(cliMsgIds) || cliMsgIds.length === 0) {
      return { statuses: {} };
    }
    const res = await axiosClient.get("/api/outbox/status", {
      params: { shopId, cliMsgIds: cliMsgIds.join(",") },
    });
    return res || { statuses: {} };
  },
};

export default outboxApi;
